/* ez-contact-capture — piggybacks the Shopify /contact form (#ez-contact-form). On submit it mirrors the
   fields to HubSpot (create the contact if new, else GAP-FILL empty props + append an inquiry note) via the
   ezsnap-contact-capture edge fn. Fire-and-forget and NON-BLOCKING: Shopify's native submit (CS email +
   thank-you page) proceeds untouched; keepalive lets the POST survive the form navigation. The honeypot
   (#ez_hp) is dropped server-side. KEY is the public Supabase anon key (safe to embed), same project as
   ez-rv-capture. Fails silent — a capture miss never affects the customer's submission (CS email is the backstop). */
(function () {
  var FN  = "https://jamovldoijekfwhmlxtm.supabase.co/functions/v1/ezsnap-contact-capture";
  var KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImphbW92bGRvaWpla2Z3aG1seHRtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzEwMTE5MjAsImV4cCI6MjA4NjU4NzkyMH0.cWgAIWDfzH4_PMXdl6jAkhkPrr630urabvpOL0582no";
  // Shopify contact[<key>] -> edge-fn payload key. Unmapped contact[...] keys are ignored.
  var MAP = {
    "email": "email", "First-name": "firstname", "Last-name": "lastname",
    "Phone": "phone", "Subject": "subject", "Vehicle": "vehicle", "body": "message",
    "Form": "form", "Address": "address", "City": "city", "State": "state", "ZIP": "zip"
  };
  function collect(form) {
    var p = {}, inputs = form.querySelectorAll('[name^="contact["]');
    for (var i = 0; i < inputs.length; i++) {
      var el = inputs[i], m = /^contact\[(.+)\]$/.exec(el.name || "");
      if (!m) continue;
      var key = MAP[m[1]];
      if (key && el.value != null && String(el.value).trim() !== "") p[key] = String(el.value).trim();
    }
    var hp = form.querySelector('[name="ez_hp"]');
    if (hp && hp.value) p.hp = hp.value;
    return p;
  }
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || form.id !== "ez-contact-form") return;
    // NOTE: no preventDefault — the native Shopify submission (CS email + confirmation) must proceed.
    try {
      var p = collect(form);
      if (!p.email) return;
      fetch(FN, {
        method: "POST",
        headers: { Authorization: "Bearer " + KEY, apikey: KEY, "Content-Type": "application/json" },
        body: JSON.stringify(p),
        keepalive: true
      }).catch(function () {});
    } catch (err) { /* never block the form */ }
  }, true);
})();
